import { Grid } from '@mui/material';
import { ApexOptions } from 'apexcharts';
import { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { getSpecificJobPipelineData } from 'wisestep-api';
import { WsTypography } from 'wisestep-base';

import { IAggregation, IHeatMapDataType } from '../../types';
import { makingDataPoints } from '../../utils/heatmapHelper';

import IPayloadDTOJobsCrm from './types/IPayloadDTOJobsCrm';

const SpecificJobPipelineData = ({ payload }: IPayloadDTOJobsCrm) => {
  const [aggregatedData, setAggregatedData] = useState<IAggregation[]>();

  useEffect(() => {
    const fetchData = async () => {
      const response = await getSpecificJobPipelineData(payload);
      setAggregatedData(response.data.aggregations.aggregation.buckets);
    };
    fetchData();
  }, [payload]);
  let bucketData: IHeatMapDataType[] = [];

  if (aggregatedData) {
    bucketData = makingDataPoints(aggregatedData);
  }

  const options: ApexOptions = {
    chart: {
      height: 350,
      zoom: {
        enabled: true,
      },
    },
    title: {
      text: 'Specific Job Pipeline',
    },
    xaxis: {
      title: {
        text: 'State',
      },
    },
    yaxis: {
      title: {
        text: 'Stage',
      },
    },
    plotOptions: {
      heatmap: {
        distributed: true,
        colorScale: {
          ranges: [
            {
              from: 0,
              to: 0,
              color: '#FFFFFF',
            },
            {
              from: 1,
              to: 10,
              color: '#febf5a',
            },
            {
              from: 11,
              to: 20,
              color: '#fd8d3c',
            },
            {
              from: 21,
              to: 30,
              color: '#d66b1e',
            },
          ],
        },
      },
    },
  };
  return (
    <Grid container justifyItems={'space-evenly'} spacing={2} textAlign="center">
      <Grid item xs={12}>
        <WsTypography>Job Pipeline </WsTypography>
        <ReactApexChart
          series={bucketData}
          options={options}
          type="heatmap"
          title="Specific Job Pipeline"
          height={350}
        />
      </Grid>
    </Grid>
  );
};

export default SpecificJobPipelineData;
